import { formatDate } from '../utils/formatter';
import { List, ListItem } from '@op/opds.opux';
import React, { useEffect } from 'react';
import message from '../messages/Message';
import { useLocation, useNavigate } from "react-router-dom";
import '../App.css';
import { SubFutureCategory } from '../utils/routes';
import { usePriceListContent } from '../context/PriceListContext';
import ErrorView from './ErrorView';

const FuturePrices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { futureResponse, fetchPriceListContentFuture, fetchDataPricelistFuture } = usePriceListContent();

  let futureEffectiveDates = null;

  if (futureResponse) {
    futureEffectiveDates = futureResponse.futureEffectiveDates;
  }

useEffect(() => {
    if (location.state?.scrollToElement) {
      const element = document.querySelector('h2.header');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      const data1 = await fetchPriceListContentFuture(futureEffectiveDates);
      if (!data1) {
        return <div>Loading...</div>;
      }
    }  
      fetchData();
    // eslint-disable-next-line
  }, []);

  if (!futureResponse) {
    return <div>Loading...</div>;
  }

  const { categories } = futureResponse;
  const formattedDate = formatDate(futureEffectiveDates);

   if (formattedDate.includes('NaN')) {
          return <ErrorView />;
   }

  const getPricelistCall = async (pricelistId, futureEffectiveDates) => {
    futureEffectiveDates = futureResponse.futureEffectiveDates;
    const data = await fetchDataPricelistFuture(pricelistId, futureEffectiveDates);
    if (!data) {
      return <div>Loading...</div>;
    }
      const productGroupContent = [];
      data.productGroups.forEach((productGroup) => {
        productGroup.productGroupContent.forEach((product) => {
          product.productGroupName = productGroup.productGroupName;
          productGroupContent.push(product);
        });
      });
      navigate(SubFutureCategory, { state: { productGroupContent, data } }); // set the product group content state variable to the combined product group content of all product groups
  };

  return (
    <div className="runko">
      <p className="opux-v6__opds">{message('catalog_upcoming').replace('futureEffectiveDate', formattedDate)}</p>
      {categories &&
        categories.map((category, categoryIndex) => (
          <div key={categoryIndex}>
            <h3 className="subHeader">{category.categoryName}</h3>
            <List size="small" border="none" style={{ margin: 0 }}>
              {category.categoryContent.map((subcategory, subIndex) => (
                <ListItem
                  key={subIndex}
                  onClick={() => getPricelistCall(subcategory.pricelistId)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      getPricelistCall(subcategory.pricelistId);
                    }
                  }}
                  tabIndex={0} // Make the ListItem focusable
                >
                  {subcategory.pricelistName}
                </ListItem>
              ))}
            </List>
          </div>
        ))}
    </div>
  );
}
export default FuturePrices;